module.exports = __webpack_public_path__ + "static/media/dpk.dc4d7d18.png";